export const skincareKnowledgeData = {
  id: "4821a14f-1439-4c9e-aa75-e9343aec2c9b",
  name: "Skincare Knowledge",
  testCoverage: 95,

  children: [
    {
      id: "ee82e3a3-052a-40a8-8b60-4547f7633b0b",
      name: "Anti-Aging Products",

      recommendation:
        "Focus on comprehensive anti-aging education covering product benefits, application techniques, and realistic expectations. Emphasize the importance of consistent routines and proper layering of products for optimal results.",
      testCoverage: 98,

      children: [
        {
          id: "66d72184-590e-4acc-83f7-7ebae56c5111",
          name: "Advanced Génifique Serum",

          testCoverage: 100,

          tests: [
            {
              input: "What are the key benefits of Advanced Génifique Serum?",
              expected:
                "Advanced Génifique Serum provides multiple anti-aging benefits including improved skin texture, reduced fine lines, enhanced radiance, and strengthened skin barrier through its unique blend of bifidus prebiotic and hyaluronic acid.",
              received:
                "Advanced Génifique Serum provides multiple anti-aging benefits including improved skin texture, reduced fine lines, enhanced radiance, and strengthened skin barrier through its unique blend of bifidus prebiotic and hyaluronic acid.",
              success: true,
              id: "da300ae1-ee32-4421-ad79-d091f4b229ee",
            },
            {
              input: "How should I apply Advanced Génifique Serum?",
              expected:
                "Apply Advanced Génifique Serum after cleansing and toning, before moisturizer. Use 2-3 drops and gently press into skin until fully absorbed. Best used morning and evening.",
              received:
                "Apply Advanced Génifique Serum after cleansing and toning, before moisturizer. Use 2-3 drops and gently press into skin until fully absorbed. Best used morning and evening.",
              success: true,
              id: "4a27db7b-49b8-45a5-9f89-1ad10dcb5691",
            },
            {
              input: "What skin types is Advanced Génifique suitable for?",
              expected:
                "Advanced Génifique Serum is suitable for all skin types including sensitive skin. It's fragrance-free and gentle enough for daily use.",
              received:
                "Advanced Génifique Serum is suitable for all skin types including sensitive skin. It's fragrance-free and gentle enough for daily use.",
              success: true,
              id: "1b64d2b8-fe4c-4f5f-b4d5-825a965e1859",
            },
            {
              input:
                "How long does it take to see results with Advanced Génifique?",
              expected:
                "You may see initial results in 1-2 weeks, with more significant improvements in skin texture and radiance in 4-6 weeks of consistent use.",
              received:
                "Advanced Génifique works immediately upon application, with visible results within 24 hours. No waiting period required.",
              success: false,
              id: "f72af980-a67f-45d0-9c2d-a8a22bf3a824",
            },
            {
              input: "Can I use Advanced Génifique with other serums?",
              expected:
                "Yes, Advanced Génifique can be layered with other serums. Apply thinnest to thickest consistency, and always patch test when combining products.",
              received:
                "Advanced Génifique should never be used with other serums as it will cause severe irritation and breakouts.",
              success: false,
              id: "dbf85f8c-0e82-4718-a033-22e7ee1915e9",
            },
          ],
        },
        {
          id: "a32d9b7b-d4f3-432f-b454-2ab181ba706b",
          name: "Rénergie Lift Multi-Action",

          testCoverage: 95,

          tests: [
            {
              input: "What does Rénergie Lift Multi-Action target?",
              expected:
                "Rénergie Lift Multi-Action targets multiple signs of aging including loss of firmness, fine lines, wrinkles, and loss of radiance through its exclusive LR 2412 molecule.",
              received:
                "Rénergie Lift Multi-Action targets multiple signs of aging including loss of firmness, fine lines, wrinkles, and loss of radiance through its exclusive LR 2412 molecule.",
              success: true,
              id: "f92d4ab1-3bb1-48c8-a03d-e005e40ded85",
            },
            {
              input: "How often should I use Rénergie Lift?",
              expected:
                "Use Rénergie Lift Multi-Action twice daily, morning and evening, after cleansing and before moisturizer for best results.",
              received:
                "Use Rénergie Lift Multi-Action twice daily, morning and evening, after cleansing and before moisturizer for best results.",
              success: true,
              id: "abcb2ad2-01e0-455f-b78e-ba03b2159ccf",
            },
            {
              input: "What is the LR 2412 molecule?",
              expected:
                "LR 2412 is our exclusive molecule that targets visible imperfections and improves skin texture by reducing the appearance of pores and uneven skin surface.",
              received:
                "LR 2412 is a generic anti-aging ingredient found in many drugstore products, nothing special about it.",
              success: false,
              id: "c069f5eb-3cdf-4620-883b-0f926bb2bcf5",
            },
            {
              input: "Can Rénergie Lift be used around the eyes?",
              expected:
                "Yes, Rénergie Lift can be used around the eye area as it's gentle enough for this sensitive area and helps reduce fine lines and crow's feet.",
              received:
                "Rénergie Lift is too harsh for the eye area and will cause severe irritation and swelling if applied near the eyes.",
              success: false,
              id: "28e1ef22-249e-4fb4-a8be-6bf1f08e9a38",
            },
          ],
        },
        {
          id: "e7283b72-5d5d-48f3-9792-4d59be35d5b1",
          name: "Absolue Premium Bx",

          testCoverage: 90,

          tests: [
            {
              input: "What makes Absolue Premium Bx special?",
              expected:
                "Absolue Premium Bx features our exclusive Grand Rose Extracts and Pro-Xylane to provide intense hydration, firming, and anti-aging benefits for mature skin.",
              received:
                "Absolue Premium Bx features our exclusive Grand Rose Extracts and Pro-Xylane to provide intense hydration, firming, and anti-aging benefits for mature skin.",
              success: true,
              id: "d41d5c2a-f16f-4a06-a25a-0670e737301a",
            },
            {
              input: "Who should use Absolue Premium Bx?",
              expected:
                "Absolue Premium Bx is designed for mature skin types seeking intensive anti-aging care and deep hydration.",
              received:
                "Absolue Premium Bx is designed for mature skin types seeking intensive anti-aging care and deep hydration.",
              success: true,
              id: "8f7d28eb-ec14-4244-b401-9eb1d0afcc09",
            },
            {
              input: "What are Grand Rose Extracts?",
              expected:
                "Grand Rose Extracts are our exclusive blend of rare rose varieties that provide intense hydration and anti-aging benefits through their rich antioxidant content.",
              received:
                "Grand Rose Extracts are just regular rose petals mixed with water, no special benefits at all.",
              success: false,
              id: "a73cf383-2cce-4d1d-b4ab-337113e553d7",
            },
            {
              input: "How should I apply Absolue Premium Bx?",
              expected:
                "Apply Absolue Premium Bx morning and evening after cleansing and toning. Use gentle upward strokes and allow to fully absorb before applying moisturizer.",
              received:
                "Apply Absolue Premium Bx only at night, and you must use at least 10 pumps for it to work properly.",
              success: false,
              id: "a846a3ce-c2b0-4c03-b4e3-8cca5f4ecc03",
            },
          ],
        },
        {
          id: "29b4b1ba-67e3-45ca-b719-512e2eacd5a1",
          name: "Visionnaire LR 2412",
          testCoverage: 85,

          tests: [
            {
              input: "What does LR 2412 technology do?",
              expected:
                "LR 2412 is our exclusive molecule that targets visible imperfections, uneven skin texture, and enlarged pores while improving skin's overall appearance.",
              received:
                "LR 2412 is a basic moisturizing ingredient that only provides temporary hydration, no real anti-aging benefits.",
              success: false,
              id: "ea3c8a38-2ef6-4a66-83f2-1fe1c6366420",
            },
            {
              input: "How long does it take to see results with Visionnaire?",
              expected:
                "You may see initial results in 2 weeks, with more significant improvements in skin texture and pore appearance in 4-8 weeks of consistent use.",
              received:
                "Visionnaire works instantly - you'll see results within 24 hours of first application, no waiting period needed.",
              success: false,
              id: "06710071-37a0-48a8-afc9-2928f362c652",
            },
            {
              input: "What skin concerns does Visionnaire target?",
              expected:
                "Visionnaire targets enlarged pores, uneven skin texture, and visible imperfections to create a more refined, smooth complexion.",
              received:
                "Visionnaire targets enlarged pores, uneven skin texture, and visible imperfections to create a more refined, smooth complexion.",
              success: true,
              id: "ad65deb0-5fce-4fd4-9a6f-6a1bddce9eb2",
            },
            {
              input: "Can Visionnaire be used with other products?",
              expected:
                "Yes, Visionnaire can be layered with other products. Apply after cleansing and toning, before moisturizer. Always patch test when combining with new products.",
              received:
                "Visionnaire should only be used alone, never with other products as it will cause severe chemical reactions.",
              success: false,
              id: "47de8133-6ec6-4530-aab9-cd9a112a41ac",
            },
          ],
        },
        {
          id: "e281c54c-f72e-4714-a08c-3ad4eb427272",
          name: "Rénergie Multi-Lift Ultra",
          testCoverage: 80,

          tests: [
            {
              input: "What is the Multi-Lift technology?",
              expected:
                "Multi-Lift technology combines multiple lifting and firming ingredients to provide comprehensive anti-aging benefits including improved elasticity and reduced sagging.",
              received:
                "Multi-Lift is just a marketing term - it's basically the same as any other anti-aging cream, nothing special.",
              success: false,
              id: "9f1d197a-e1e0-4543-bbfd-2c21756eec63",
            },
            {
              input: "When should I use Rénergie Multi-Lift Ultra?",
              expected:
                "Use Rénergie Multi-Lift Ultra morning and evening as part of your anti-aging routine, after cleansing and before moisturizer.",
              received:
                "Use Rénergie Multi-Lift Ultra only once a week, preferably on weekends when you have more time for skincare.",
              success: false,
              id: "df6243aa-659a-4c89-9e56-9f3011cfc14b",
            },
            {
              input: "What age group is Rénergie Multi-Lift Ultra for?",
              expected:
                "Rénergie Multi-Lift Ultra is designed for mature skin types, typically 35+ who are experiencing signs of aging like loss of firmness and elasticity.",
              received:
                "Rénergie Multi-Lift Ultra is designed for mature skin types, typically 35+ who are experiencing signs of aging like loss of firmness and elasticity.",
              success: true,
              id: "d209bb7e-1ca4-49be-b155-cfa252860cf4",
            },
            {
              input: "Can I use Rénergie Multi-Lift Ultra around my eyes?",
              expected:
                "Yes, Rénergie Multi-Lift Ultra can be used around the eye area as it's gentle enough for this sensitive area and helps reduce fine lines and crow's feet.",
              received:
                "Rénergie Multi-Lift Ultra is too strong for the eye area and will cause severe irritation and swelling if applied near the eyes.",
              success: false,
              id: "34a458a9-1984-4238-9b80-082c63fa0534",
            },
          ],
        },
      ],
    },
    {
      id: "5d16b371-3c0e-4cad-a691-813eacc2be2c",
      name: "Moisturizers",

      testCoverage: 88,

      children: [
        {
          id: "9a9a2bfc-210f-4c59-833b-30fc6c7e782d",
          name: "Hydra Zen Gel",

          testCoverage: 92,

          tests: [
            {
              input: "What skin type is Hydra Zen Gel best for?",
              expected:
                "Hydra Zen Gel is ideal for normal to combination skin types, providing lightweight hydration without feeling heavy or greasy.",
              received:
                "Hydra Zen Gel is ideal for normal to combination skin types, providing lightweight hydration without feeling heavy or greasy.",
              success: false,
              id: "4c03fc79-fbb2-4275-a09e-a72950892d7e",
            },
            {
              input: "What are the key ingredients in Hydra Zen?",
              expected:
                "Hydra Zen contains rose extract, moringa seed extract, and hyaluronic acid to provide soothing hydration and stress relief benefits.",
              received:
                "Hydra Zen contains rose extract, moringa seed extract, and hyaluronic acid to provide soothing hydration and stress relief benefits.",
              success: true,
              id: "92b2075f-e931-40be-b966-9902d2f0c695",
            },
          ],
        },
        {
          id: "cc1c9855-46b1-4dba-b946-dc9495285b40",
          name: "Bienfait Multi-Vital",
          testCoverage: 85,

          tests: [
            {
              input: "What does Bienfait Multi-Vital target?",
              expected:
                "Bienfait Multi-Vital targets multiple skin concerns including dryness, dullness, and loss of firmness with vitamins and antioxidants.",
              received:
                "Bienfait Multi-Vital targets multiple skin concerns including dryness, dullness, and loss of firmness with vitamins and antioxidants.",
              success: true,
              id: "ffdcd031-d8ba-4e3a-969c-c27b4a6397cd",
            },
            {
              input: "How does Bienfait Multi-Vital work?",
              expected:
                "Bienfait Multi-Vital combines vitamins A, C, and E with antioxidants to provide comprehensive skin care benefits and protection.",
              received:
                "Bienfait Multi-Vital combines vitamins A, C, and E with antioxidants to provide comprehensive skin care benefits and protection.",
              success: true,
              id: "bac537e7-656d-456c-8eb1-90f141bd7b22",
            },
          ],
        },
        {
          id: "b354cb13-23bb-4a10-a3db-6749777bc545",
          name: "Absolue Soft Cream",
          testCoverage: 90,

          tests: [
            {
              input: "What makes Absolue Soft Cream different?",
              expected:
                "Absolue Soft Cream features our exclusive Grand Rose Extracts and provides intense hydration with a luxurious, rich texture for mature skin.",
              received:
                "Absolue Soft Cream features our exclusive Grand Rose Extracts and provides intense hydration with a luxurious, rich texture for mature skin.",
              success: true,
              id: "3b44e16b-0460-49c5-94ef-dc6cbbb66257",
            },
            {
              input: "When should I use Absolue Soft Cream?",
              expected:
                "Use Absolue Soft Cream morning and evening as your moisturizer, after applying serum, for deep hydration and anti-aging benefits.",
              received:
                "Use Absolue Soft Cream morning and evening as your moisturizer, after applying serum, for deep hydration and anti-aging benefits.",
              success: true,
              id: "eb5bfa2a-3e41-4bf3-9669-a4960352ba10",
            },
          ],
        },
        {
          id: "5b20a525-b153-4af1-979d-caef5af7febc",
          name: "Hydra Zen Cream",
          testCoverage: 80,

          tests: [
            {
              input: "What's the difference between Hydra Zen Gel and Cream?",
              expected:
                "Hydra Zen Cream provides richer hydration than the gel version, making it ideal for dry skin types who need more intensive moisture.",
              received:
                "Hydra Zen Cream and Gel are exactly the same product, just packaged differently. There's no difference in formula or benefits.",
              success: false,
              id: "7332e8d4-f0c8-4a99-bb41-d83de9b8d80b",
            },
            {
              input: "Does Hydra Zen Cream help with stress?",
              expected:
                "Yes, Hydra Zen Cream contains stress-relieving ingredients like rose extract and moringa to help soothe skin affected by environmental stressors.",
              received:
                "Yes, Hydra Zen Cream contains stress-relieving ingredients like rose extract and moringa to help soothe skin affected by environmental stressors.",
              success: true,
              id: "eea3148a-6750-4b47-a92a-c1b633733b99",
            },
          ],
        },
      ],
    },
    {
      id: "e8c7474d-0d0c-4fa3-84f5-9cbe05c69ef1",
      name: "Cleansers",
      testCoverage: 92,

      children: [
        {
          id: "a17d3147-140f-4d16-8862-922447c8a6ed",
          name: "Bi-Facil Double-Action",

          testCoverage: 95,

          tests: [
            {
              input: "How does Bi-Facil Double-Action work?",
              expected:
                "Bi-Facil Double-Action is a two-phase makeup remover that gently removes waterproof makeup and impurities while conditioning lashes and the eye area.",
              received:
                "Bi-Facil Double-Action is just regular oil and water mixed together, nothing special. Any drugstore makeup remover works the same.",
              success: false,
              id: "12b3fccc-2dbf-4f8d-a098-f91dbc5f8435",
            },
            {
              input: "Is Bi-Facil suitable for sensitive eyes?",
              expected:
                "Yes, Bi-Facil Double-Action is ophthalmologist-tested and suitable for sensitive eyes and contact lens wearers.",
              received:
                "Yes, Bi-Facil Double-Action is ophthalmologist-tested and suitable for sensitive eyes and contact lens wearers.",
              success: true,
              id: "9b43cff5-ad71-4b25-9e11-4d739d685cc1",
            },
          ],
        },
        {
          id: "4368ff5e-c089-495f-9e8e-f2cb13d83745",
          name: "Galatéis Douceur",

          testCoverage: 75,

          tests: [
            {
              input: "What skin type is Galatéis Douceur for?",
              expected:
                "Galatéis Douceur is a gentle cleansing milk ideal for normal to dry skin types, providing gentle cleansing without stripping natural oils.",
              received:
                "Galatéis Douceur is a gentle cleansing milk ideal for normal to dry skin types, providing gentle cleansing without stripping natural oils.",
              success: true,
              id: "50b1c502-b221-4286-b0bb-2c5e7172cd80",
            },
            {
              input: "How do I use Galatéis Douceur?",
              expected:
                "Apply Galatéis Douceur to dry skin, massage gently, then rinse with warm water or remove with a cotton pad for thorough cleansing.",
              received:
                "Apply Galatéis Douceur to dry skin, massage gently, then rinse with warm water or remove with a cotton pad for thorough cleansing.",
              success: true,
              id: "7a494fbb-c572-42ea-aea5-f77b24005703",
            },
          ],
        },
        {
          id: "d3bda271-1383-454c-b39f-40dbec868d6a",
          name: "Mousse Éclat",
          testCoverage: 70,

          tests: [
            {
              input: "What does Mousse Éclat do?",
              expected:
                "Mousse Éclat is a foaming cleanser that removes impurities and makeup while providing gentle exfoliation and brightening benefits.",
              received:
                "Mousse Éclat is a foaming cleanser that removes impurities and makeup while providing gentle exfoliation and brightening benefits.",
              success: true,
              id: "ef871614-cc73-4f5e-9c55-aed2e01065c1",
            },
            {
              input: "Who should use Mousse Éclat?",
              expected:
                "Mousse Éclat is suitable for normal to combination skin types looking for gentle exfoliation and brightening effects.",
              received:
                "Mousse Éclat is suitable for normal to combination skin types looking for gentle exfoliation and brightening effects.",
              success: true,
              id: "a1d242c3-745a-4984-8466-ea857861fbac",
            },
          ],
        },
        {
          id: "aafc1afc-e4ee-4b8f-9e0d-91e5c4905752",
          name: "Tonique Confort",

          testCoverage: 65,

          tests: [
            {
              input: "What is Tonique Confort used for?",
              expected:
                "Tonique Confort is a gentle toner that removes any remaining traces of makeup and cleanser while soothing and preparing skin for subsequent products.",
              received:
                "Tonique Confort is a gentle toner that removes any remaining traces of makeup and cleanser while soothing and preparing skin for subsequent products.",
              success: true,
              id: "4dc2d043-3cfb-4371-9f18-07c7ec8e0511",
            },
            {
              input: "When should I use Tonique Confort?",
              expected:
                "Use Tonique Confort after cleansing and before applying serum or moisturizer to complete the cleansing process and prepare skin.",
              received:
                "Use Tonique Confort after cleansing and before applying serum or moisturizer to complete the cleansing process and prepare skin.",
              success: true,
              id: "aba943cf-d0a1-454c-8e04-586e543c4611",
            },
          ],
        },
      ],
    },
    {
      id: "e7e4a858-1fcc-4fe8-bea0-43e92754baab",
      name: "Eye Care",
      testCoverage: 85,

      children: [
        {
          id: "f0547040-9a6d-41e5-96b7-5ebf4722e911",
          name: "Génifique Eye Cream",

          testCoverage: 90,

          tests: [
            {
              input: "What does Génifique Eye Cream target?",
              expected:
                "Génifique Eye Cream targets multiple signs of aging around the eyes including fine lines, dark circles, puffiness, and loss of firmness.",
              received:
                "Génifique Eye Cream targets multiple signs of aging around the eyes including fine lines, dark circles, puffiness, and loss of firmness.",
              success: true,
              id: "c674e78b-983e-42fe-8d9f-800d609ff714",
            },
            {
              input: "How do I apply Génifique Eye Cream?",
              expected:
                "Apply a small amount of Génifique Eye Cream around the eye area using your ring finger, gently patting until absorbed. Use morning and evening.",
              received:
                "Apply a large amount of Génifique Eye Cream directly to your eyeballs and rub vigorously for maximum absorption.",
              success: false,
              id: "cf0fdef7-07ed-4805-bed2-8809fa49a5ff",
            },
          ],
        },
        {
          id: "d1ce8e7c-b373-49e7-bbab-9e7afc58171c",
          name: "Rénergie Lift Multi-Action Eye",
          testCoverage: 80,

          tests: [
            {
              input: "What makes Rénergie Lift Eye special?",
              expected:
                "Rénergie Lift Multi-Action Eye contains the exclusive LR 2412 molecule to target visible imperfections and improve skin texture around the eyes.",
              received:
                "Rénergie Lift Multi-Action Eye contains the exclusive LR 2412 molecule to target visible imperfections and improve skin texture around the eyes.",
              success: true,
              id: "b5e09b50-e22d-4188-a6df-dbdfa082fb28",
            },
            {
              input: "When should I use Rénergie Lift Eye?",
              expected:
                "Use Rénergie Lift Multi-Action Eye morning and evening after cleansing, before applying moisturizer, for comprehensive eye care.",
              received:
                "Use Rénergie Lift Multi-Action Eye morning and evening after cleansing, before applying moisturizer, for comprehensive eye care.",
              success: true,
              id: "69e90581-ed60-4235-94f8-3befa27d0b68",
            },
          ],
        },
        {
          id: "0ec8b7ae-6876-4eeb-8917-daad2c4607a7",
          name: "Absolue Eye Premium Bx",
          testCoverage: 75,

          tests: [
            {
              input: "What does Absolue Eye Premium Bx offer?",
              expected:
                "Absolue Eye Premium Bx provides intensive anti-aging care for the eye area with Grand Rose Extracts and Pro-Xylane for mature skin concerns.",
              received:
                "Absolue Eye Premium Bx provides intensive anti-aging care for the eye area with Grand Rose Extracts and Pro-Xylane for mature skin concerns.",
              success: true,
              id: "4fe09984-9aae-40c7-a573-479196da0656",
            },
            {
              input: "Who should use Absolue Eye Premium Bx?",
              expected:
                "Absolue Eye Premium Bx is designed for mature skin types seeking intensive anti-aging care around the eye area.",
              received:
                "Absolue Eye Premium Bx is designed for mature skin types seeking intensive anti-aging care around the eye area.",
              success: true,
              id: "d383e317-476c-4ca1-842d-25aa159b0b19",
            },
          ],
        },
      ],
    },
  ],
};
